import { lightTheme } from '../../styles';
import { ProgressFill, ProgressTrack } from './ProgressMeter.styled';

type Props = {
  /** How far along, 0 to 1. Clamped, so a count past its goal reads as full. */
  value: number;
  /** Defaults to the brand red. */
  color?: string;
  /** In px. */
  height?: number;
  /** What the bar measures, for screen readers ("7 of 10 orders"). */
  label?: string;
};

/** A thin rounded bar that fills from the left. */
export const ProgressMeter = ({ value, color, height = 6, label }: Props) => {
  const clamped = Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0));

  return (
    <ProgressTrack
      $height={height}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clamped * 100)}
      aria-label={label}
    >
      <ProgressFill
        $color={color || lightTheme.primary}
        style={{ transform: `scaleX(${clamped})` }}
      />
    </ProgressTrack>
  );
};
